import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
/**
 * 瀑布图
 */

var Waterfall =
/** @class */
function (_super) {
  __extends(Waterfall, _super);

  function Waterfall() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'waterfall';
    return _this;
  }
  /**
   * 获取 瀑布图 的适配器
   */


  Waterfall.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };
  /**
   * 获取 瀑布图 的默认配置
   */


  Waterfall.prototype.getDefaultOptions = function (options) {
    var yField = options.yField;
    return {
      tooltip: {
        showCrosshairs: false,
        showMarkers: false,
        shared: true,
        // tooltip 默认展示 y 字段值
        fields: [yField]
      },

      /** default: show label */
      label: {},

      /** default: show leaderLine */
      leaderLine: {
        style: {
          lineWidth: 1,
          stroke: '#8c8c8c',
          lineDash: [4, 2]
        }
      },

      /** default: show total */
      total: {
        label: '总计',
        style: {
          fill: 'rgba(0, 0, 0, 0.25)'
        }
      },
      interactions: [{
        type: 'element-active'
      }],
      risingFill: '#f4664a',
      fallingFill: '#30bf78',
      waterfallStyle: {
        fill: 'rgba(0, 0, 0, 0.25)'
      }
    };
  };

  return Waterfall;
}(Plot);

export { Waterfall };